// Module
var code = "<div class=\"faq-teasers-spot\"> <faq-teasers group=\"$ctrl.group\"></faq-teasers> </div>";
// Exports
module.exports = code;